var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZ9(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 119.543 118.814",
    width: 119.543,
    height: 118.814,
    enableBackground: "new 0 0 119.543 118.814",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M104.668,13.142V0H44.626H29.75H14.875v13.142H0V92.53v13.142h14.875v13.142h60.042h14.875h14.875v-13.142 H89.792H74.917H29.75V92.53H14.875V26.284H29.75v13.202h15.01h15.01h0.038h14.972h0.013v13.172H59.886v13.261h15.01V52.746h14.909 V39.485h-0.013V26.284h14.875v52.963H59.835V65.963h-15.01v13.284H29.75v13.261h74.917h14.875V79.246V13.142H104.668z  M89.792,26.224h-15.01H59.809h-0.038h-15.01H29.75V13.142h14.875h45.167V26.224z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZ9);
export default __webpack_public_path__ + "static/media/z9.64224b7e6f147c749d4ecd90393430fc.svg";
export { ForwardRef as ReactComponent };